// Generated by scripts/generate-blog-index.js. Edit the Markdown files in public/blog instead.
export const posts = [
  {
    "slug": "interview-001-var-let-const",
    "title": "1. What is the difference between var, let, and const?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Choose a declaration by the lifetime of its binding and whether you intend to reassign it.",
    "series": "interview",
    "questionNumber": "1",
    "contentPath": "/blog/interview-001-var-let-const.md"
  },
  {
    "slug": "interview-002-primitive-reference-types",
    "title": "2. What are primitive and reference data types?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "JavaScript has seven primitive types: string, number, bigint, boolean, undefined, symbol and null.",
    "series": "interview",
    "questionNumber": "2",
    "contentPath": "/blog/interview-002-primitive-reference-types.md"
  },
  {
    "slug": "interview-003-type-coercion",
    "title": "3. What is type coercion in JavaScript?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Coercion converts a value to another type.",
    "series": "interview",
    "questionNumber": "3",
    "contentPath": "/blog/interview-003-type-coercion.md"
  },
  {
    "slug": "interview-004-loose-strict-equality",
    "title": "4. What is the difference between == and ===?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Strict equality, ===, compares without converting operands to a shared type.",
    "series": "interview",
    "questionNumber": "4",
    "contentPath": "/blog/interview-004-loose-strict-equality.md"
  },
  {
    "slug": "interview-005-truthy-falsy",
    "title": "5. What are truthy and falsy values?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A condition converts its value to a boolean.",
    "series": "interview",
    "questionNumber": "5",
    "contentPath": "/blog/interview-005-truthy-falsy.md"
  },
  {
    "slug": "interview-006-hoisting",
    "title": "6. What is hoisting?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Hoisting is a way to describe how declarations affect their scope before execution reaches their written position.",
    "series": "interview",
    "questionNumber": "6",
    "contentPath": "/blog/interview-006-hoisting.md"
  },
  {
    "slug": "interview-007-temporal-dead-zone",
    "title": "7. What is the Temporal Dead Zone?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "The Temporal Dead Zone is the period after a lexical scope is entered but before a let, const or class binding is initialized.",
    "series": "interview",
    "questionNumber": "7",
    "contentPath": "/blog/interview-007-temporal-dead-zone.md"
  },
  {
    "slug": "interview-008-lexical-scope",
    "title": "8. What is lexical scope?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Lexical scope means the source location where a function is defined determines which surrounding bindings it can access.",
    "series": "interview",
    "questionNumber": "8",
    "contentPath": "/blog/interview-008-lexical-scope.md"
  },
  {
    "slug": "interview-009-scope-chain",
    "title": "9. What is scope chaining?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "When JavaScript resolves an identifier, it checks the current lexical environment and then successive outer environments until it finds a matching binding.",
    "series": "interview",
    "questionNumber": "9",
    "contentPath": "/blog/interview-009-scope-chain.md"
  },
  {
    "slug": "interview-010-closure",
    "title": "10. What is a closure?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A closure is a function together with access to its surrounding lexical environment.",
    "series": "interview",
    "questionNumber": "10",
    "contentPath": "/blog/interview-010-closure.md"
  },
  {
    "slug": "interview-011-closure-use-cases",
    "title": "11. What are practical use cases of closures?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Closures let a function carry a small amount of context without global state.",
    "series": "interview",
    "questionNumber": "11",
    "contentPath": "/blog/interview-011-closure-use-cases.md"
  },
  {
    "slug": "interview-012-this-keyword",
    "title": "12. How does the this keyword work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "For an ordinary function, this is usually determined by how it is called.",
    "series": "interview",
    "questionNumber": "12",
    "contentPath": "/blog/interview-012-this-keyword.md"
  },
  {
    "slug": "interview-013-arrow-this",
    "title": "13. How is this different in arrow functions?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "An arrow function does not create its own this binding.",
    "series": "interview",
    "questionNumber": "13",
    "contentPath": "/blog/interview-013-arrow-this.md"
  },
  {
    "slug": "interview-014-call-apply-bind",
    "title": "14. Explain call, apply, and bind.",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "These methods control the receiver of an ordinary function.",
    "series": "interview",
    "questionNumber": "14",
    "contentPath": "/blog/interview-014-call-apply-bind.md"
  },
  {
    "slug": "interview-015-prototypes-chain",
    "title": "15. What are prototypes and prototype chains?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "An object's prototype is another object used for inherited property lookup.",
    "series": "interview",
    "questionNumber": "15",
    "contentPath": "/blog/interview-015-prototypes-chain.md"
  },
  {
    "slug": "interview-016-javascript-inheritance",
    "title": "16. How does inheritance work in JavaScript?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "JavaScript inheritance delegates property lookup through prototypes.",
    "series": "interview",
    "questionNumber": "16",
    "contentPath": "/blog/interview-016-javascript-inheritance.md"
  },
  {
    "slug": "interview-017-class-constructor-function",
    "title": "17. What is the difference between a class and a constructor function?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Both can create objects whose shared methods live on a prototype.",
    "series": "interview",
    "questionNumber": "17",
    "contentPath": "/blog/interview-017-class-constructor-function.md"
  },
  {
    "slug": "interview-018-shallow-deep-copy",
    "title": "18. What is the difference between shallow copy and deep copy?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A shallow copy creates a new outer container while preserving references to nested objects.",
    "series": "interview",
    "questionNumber": "18",
    "contentPath": "/blog/interview-018-shallow-deep-copy.md"
  },
  {
    "slug": "interview-019-safe-object-cloning",
    "title": "19. How can you clone an object safely?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Start by defining what kinds of values the object contains and what the clone must preserve.",
    "series": "interview",
    "questionNumber": "19",
    "contentPath": "/blog/interview-019-safe-object-cloning.md"
  },
  {
    "slug": "interview-020-freeze-seal",
    "title": "20. What is the difference between Object.freeze() and Object.seal()?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Both prevent adding or deleting own properties.",
    "series": "interview",
    "questionNumber": "20",
    "contentPath": "/blog/interview-020-freeze-seal.md"
  },
  {
    "slug": "interview-021-event-loop",
    "title": "21. What is the JavaScript event loop?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "The event loop coordinates queued work with JavaScript execution.",
    "series": "interview",
    "questionNumber": "21",
    "contentPath": "/blog/interview-021-event-loop.md"
  },
  {
    "slug": "interview-022-stack-web-apis-queue",
    "title": "22. What are the call stack, Web APIs, and callback queue?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "The call stack tracks active JavaScript function calls.",
    "series": "interview",
    "questionNumber": "22",
    "contentPath": "/blog/interview-022-stack-web-apis-queue.md"
  },
  {
    "slug": "interview-023-microtasks-macrotasks",
    "title": "23. What is the difference between microtasks and macrotasks?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A task, often informally called a macrotask, includes work such as a timer callback or event dispatch.",
    "series": "interview",
    "questionNumber": "23",
    "contentPath": "/blog/interview-023-microtasks-macrotasks.md"
  },
  {
    "slug": "interview-024-async-execution-order",
    "title": "24. In what order do promises, timers, and synchronous code execute?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "For a basic browser script, synchronous code finishes first, already-queued promise continuations run at the microtask checkpoint, and eligible timer tasks run afterward.",
    "series": "interview",
    "questionNumber": "24",
    "contentPath": "/blog/interview-024-async-execution-order.md"
  },
  {
    "slug": "interview-025-promise",
    "title": "25. What is a Promise?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A Promise represents an eventual result: either a fulfillment value or a rejection reason.",
    "series": "interview",
    "questionNumber": "25",
    "contentPath": "/blog/interview-025-promise.md"
  },
  {
    "slug": "interview-026-promise-states",
    "title": "26. What are the states of a Promise?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A promise is pending, fulfilled or rejected.",
    "series": "interview",
    "questionNumber": "26",
    "contentPath": "/blog/interview-026-promise-states.md"
  },
  {
    "slug": "interview-027-async-await",
    "title": "27. How does async/await work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "An async function always returns a promise.",
    "series": "interview",
    "questionNumber": "27",
    "contentPath": "/blog/interview-027-async-await.md"
  },
  {
    "slug": "interview-028-promise-combinators",
    "title": "28. What is the difference between Promise.all, allSettled, race, and any?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Choose the combinator by the result contract.",
    "series": "interview",
    "questionNumber": "28",
    "contentPath": "/blog/interview-028-promise-combinators.md"
  },
  {
    "slug": "interview-029-async-error-handling",
    "title": "29. How do you handle errors in asynchronous JavaScript?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Attach error handling to the asynchronous chain that can fail.",
    "series": "interview",
    "questionNumber": "29",
    "contentPath": "/blog/interview-029-async-error-handling.md"
  },
  {
    "slug": "interview-030-callback-hell",
    "title": "30. What is callback hell and how can you avoid it?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Callback hell describes control flow that becomes difficult to follow because each dependent operation is nested inside another callback.",
    "series": "interview",
    "questionNumber": "30",
    "contentPath": "/blog/interview-030-callback-hell.md"
  },
  {
    "slug": "interview-031-debouncing",
    "title": "31. What is debouncing?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Debouncing postpones work until calls have stopped for a chosen interval.",
    "series": "interview",
    "questionNumber": "31",
    "contentPath": "/blog/interview-031-debouncing.md"
  },
  {
    "slug": "interview-032-throttling",
    "title": "32. What is throttling?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Throttling limits execution frequency while calls continue.",
    "series": "interview",
    "questionNumber": "32",
    "contentPath": "/blog/interview-032-throttling.md"
  },
  {
    "slug": "interview-033-currying",
    "title": "33. What is currying?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Currying transforms a function that accepts several arguments into a chain of functions that each accepts one argument.",
    "series": "interview",
    "questionNumber": "33",
    "contentPath": "/blog/interview-033-currying.md"
  },
  {
    "slug": "interview-034-infinite-currying",
    "title": "34. What is infinite currying?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "“Infinite currying” usually means an API that accepts an open-ended chain of calls until an explicit terminator returns the result.",
    "series": "interview",
    "questionNumber": "34",
    "contentPath": "/blog/interview-034-infinite-currying.md"
  },
  {
    "slug": "interview-035-memoization",
    "title": "35. What is memoization?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Memoization reuses a previous result when the same inputs are supplied again.",
    "series": "interview",
    "questionNumber": "35",
    "contentPath": "/blog/interview-035-memoization.md"
  },
  {
    "slug": "interview-036-pure-functions-immutability",
    "title": "36. What are pure functions and immutability?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A pure function produces the same result for the same inputs and does not cause observable side effects.",
    "series": "interview",
    "questionNumber": "36",
    "contentPath": "/blog/interview-036-pure-functions-immutability.md"
  },
  {
    "slug": "interview-037-bubbling-capturing",
    "title": "37. What is event bubbling and event capturing?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "DOM event propagation has a capture phase toward the target, a target phase, and, for bubbling events, a bubble phase through ancestors.",
    "series": "interview",
    "questionNumber": "37",
    "contentPath": "/blog/interview-037-bubbling-capturing.md"
  },
  {
    "slug": "interview-038-event-delegation",
    "title": "38. What is event delegation?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Event delegation handles events for multiple children through a listener on an ancestor.",
    "series": "interview",
    "questionNumber": "38",
    "contentPath": "/blog/interview-038-event-delegation.md"
  },
  {
    "slug": "interview-039-modules-tree-shaking",
    "title": "39. What are ES modules, CommonJS, and tree shaking?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "ES modules use import and export with statically analyzable declarations and live bindings.",
    "series": "interview",
    "questionNumber": "39",
    "contentPath": "/blog/interview-039-modules-tree-shaking.md"
  },
  {
    "slug": "interview-040-memory-leaks",
    "title": "40. How do memory leaks happen in JavaScript, and how can you prevent them?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "A leak occurs when objects that are no longer useful remain reachable from live roots.",
    "series": "interview",
    "questionNumber": "40",
    "contentPath": "/blog/interview-040-memory-leaks.md"
  },
  {
    "slug": "interview-041-what-is-react",
    "title": "41. What is React, and why is it used?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "React is a library for describing user interfaces with components.",
    "series": "interview",
    "questionNumber": "41",
    "contentPath": "/blog/interview-041-what-is-react.md"
  },
  {
    "slug": "interview-042-jsx",
    "title": "42. What is JSX?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "JSX is a syntax extension that lets JavaScript describe element trees with markup-like notation.",
    "series": "interview",
    "questionNumber": "42",
    "contentPath": "/blog/interview-042-jsx.md"
  },
  {
    "slug": "interview-043-jsx-compilation",
    "title": "43. How does JSX get converted into JavaScript?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "A compiler such as Babel or the framework's compiler transforms JSX into calls that create React element descriptions.",
    "series": "interview",
    "questionNumber": "43",
    "contentPath": "/blog/interview-043-jsx-compilation.md"
  },
  {
    "slug": "interview-044-virtual-dom",
    "title": "44. What is the Virtual DOM?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Virtual DOM is a common name for the in-memory UI descriptions React uses to determine what the host UI should look like.",
    "series": "interview",
    "questionNumber": "44",
    "contentPath": "/blog/interview-044-virtual-dom.md"
  },
  {
    "slug": "interview-045-reconciliation",
    "title": "45. What is reconciliation?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Reconciliation is the process of matching new element output to existing UI identities so React can decide what to preserve, update or replace.",
    "series": "interview",
    "questionNumber": "45",
    "contentPath": "/blog/interview-045-reconciliation.md"
  },
  {
    "slug": "interview-046-react-fiber",
    "title": "46. What is React Fiber?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Fiber is React's internal architecture for representing component work and scheduling reconciliation.",
    "series": "interview",
    "questionNumber": "46",
    "contentPath": "/blog/interview-046-react-fiber.md"
  },
  {
    "slug": "interview-047-list-keys",
    "title": "47. Why are keys important when rendering lists?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Keys give sibling elements stable identities across insertions, removals and reordering.",
    "series": "interview",
    "questionNumber": "47",
    "contentPath": "/blog/interview-047-list-keys.md"
  },
  {
    "slug": "interview-048-index-keys",
    "title": "48. Why should array indexes usually not be used as keys?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "An index describes a position, not the identity of the data occupying it.",
    "series": "interview",
    "questionNumber": "48",
    "contentPath": "/blog/interview-048-index-keys.md"
  },
  {
    "slug": "interview-049-props-state",
    "title": "49. What is the difference between props and state?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Props are inputs supplied by a parent.",
    "series": "interview",
    "questionNumber": "49",
    "contentPath": "/blog/interview-049-props-state.md"
  },
  {
    "slug": "interview-050-controlled-uncontrolled",
    "title": "50. What is the difference between controlled and uncontrolled components?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "For a controlled input, React state supplies the current value and an event handler updates that state.",
    "series": "interview",
    "questionNumber": "50",
    "contentPath": "/blog/interview-050-controlled-uncontrolled.md"
  },
  {
    "slug": "interview-051-use-state",
    "title": "51. How does useState work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "useState associates a state value and an update queue with a component instance.",
    "series": "interview",
    "questionNumber": "51",
    "contentPath": "/blog/interview-051-use-state.md"
  },
  {
    "slug": "interview-052-functional-state-updates",
    "title": "52. Why should functional updates be used with state?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Use an updater function when the next state depends on pending previous state.",
    "series": "interview",
    "questionNumber": "52",
    "contentPath": "/blog/interview-052-functional-state-updates.md"
  },
  {
    "slug": "interview-053-state-batching",
    "title": "53. How does React batch state updates?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Batching lets React process multiple state updates together instead of committing a separate UI update for each setter.",
    "series": "interview",
    "questionNumber": "53",
    "contentPath": "/blog/interview-053-state-batching.md"
  },
  {
    "slug": "interview-054-use-effect",
    "title": "54. How does useEffect work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "useEffect synchronizes a committed component with an external system, such as a subscription, browser event or third-party widget.",
    "series": "interview",
    "questionNumber": "54",
    "contentPath": "/blog/interview-054-use-effect.md"
  },
  {
    "slug": "interview-055-effect-dependencies",
    "title": "55. How does the dependency array of useEffect work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Dependencies describe the reactive values read by an effect.",
    "series": "interview",
    "questionNumber": "55",
    "contentPath": "/blog/interview-055-effect-dependencies.md"
  },
  {
    "slug": "interview-056-effect-cleanup",
    "title": "56. How do you clean up an effect?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Return a cleanup function from the effect setup.",
    "series": "interview",
    "questionNumber": "56",
    "contentPath": "/blog/interview-056-effect-cleanup.md"
  },
  {
    "slug": "interview-057-effect-layout-effect",
    "title": "57. What is the difference between useEffect and useLayoutEffect?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Both synchronize with committed UI, but useLayoutEffect runs before the browser repaints and can block that paint.",
    "series": "interview",
    "questionNumber": "57",
    "contentPath": "/blog/interview-057-effect-layout-effect.md"
  },
  {
    "slug": "interview-058-use-ref-purpose",
    "title": "58. What is the purpose of useRef?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "useRef returns a stable object whose current property persists between renders.",
    "series": "interview",
    "questionNumber": "58",
    "contentPath": "/blog/interview-058-use-ref-purpose.md"
  },
  {
    "slug": "interview-059-ref-versus-state",
    "title": "59. What is the difference between useRef and useState?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "State changes request rendering; ref mutations do not.",
    "series": "interview",
    "questionNumber": "59",
    "contentPath": "/blog/interview-059-ref-versus-state.md"
  },
  {
    "slug": "interview-060-use-memo",
    "title": "60. When should you use useMemo?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Use useMemo to cache a calculation between renders when its dependencies are unchanged and repeating the calculation has a measurable cost, or when stable result identity helps another optimization.",
    "series": "interview",
    "questionNumber": "60",
    "contentPath": "/blog/interview-060-use-memo.md"
  },
  {
    "slug": "interview-061-use-callback",
    "title": "61. When should you use useCallback?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "useCallback caches a function identity while dependencies remain unchanged.",
    "series": "interview",
    "questionNumber": "61",
    "contentPath": "/blog/interview-061-use-callback.md"
  },
  {
    "slug": "interview-062-react-memo",
    "title": "62. What does React.memo do?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "memo wraps a component so React can skip rendering it when its props compare equal.",
    "series": "interview",
    "questionNumber": "62",
    "contentPath": "/blog/interview-062-react-memo.md"
  },
  {
    "slug": "interview-063-memoization-apis",
    "title": "63. What is the difference between useMemo, useCallback, and React.memo?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "useMemo caches a calculated value, useCallback caches a function identity, and memo can skip a component render when props are unchanged.",
    "series": "interview",
    "questionNumber": "63",
    "contentPath": "/blog/interview-063-memoization-apis.md"
  },
  {
    "slug": "interview-064-prop-drilling",
    "title": "64. What is prop drilling?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Prop drilling means passing data through intermediate components that do not use it themselves, solely to reach a descendant.",
    "series": "interview",
    "questionNumber": "64",
    "contentPath": "/blog/interview-064-prop-drilling.md"
  },
  {
    "slug": "interview-065-context-api",
    "title": "65. How does the Context API work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Context lets a provider make a value available to descendants without forwarding it through every intermediate component.",
    "series": "interview",
    "questionNumber": "65",
    "contentPath": "/blog/interview-065-context-api.md"
  },
  {
    "slug": "interview-066-avoid-context",
    "title": "66. When should Context be avoided?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Avoid Context for state that belongs to one small subtree, or for a rapidly changing broad object consumed by many unrelated components.",
    "series": "interview",
    "questionNumber": "66",
    "contentPath": "/blog/interview-066-avoid-context.md"
  },
  {
    "slug": "interview-067-custom-hooks",
    "title": "67. What are custom hooks?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "A custom hook is a function that composes React hooks to expose reusable stateful behavior.",
    "series": "interview",
    "questionNumber": "67",
    "contentPath": "/blog/interview-067-custom-hooks.md"
  },
  {
    "slug": "interview-068-sharing-react-logic",
    "title": "68. How do you share logic between React components?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Choose the smallest mechanism that matches what is shared.",
    "series": "interview",
    "questionNumber": "68",
    "contentPath": "/blog/interview-068-sharing-react-logic.md"
  },
  {
    "slug": "interview-069-error-boundaries",
    "title": "69. What are error boundaries?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "An error boundary displays fallback UI when a descendant fails during rendering or related React lifecycle work.",
    "series": "interview",
    "questionNumber": "69",
    "contentPath": "/blog/interview-069-error-boundaries.md"
  },
  {
    "slug": "interview-070-suspense-lazy-splitting",
    "title": "70. What are Suspense, lazy loading, and code splitting in React?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Code splitting divides a bundle into separately loadable chunks.",
    "series": "interview",
    "questionNumber": "70",
    "contentPath": "/blog/interview-070-suspense-lazy-splitting.md"
  },
  {
    "slug": "interview-071-nextjs-versus-react",
    "title": "71. What is Next.js, and how is it different from React?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "React provides the component model for building UI.",
    "series": "interview",
    "questionNumber": "71",
    "contentPath": "/blog/interview-071-nextjs-versus-react.md"
  },
  {
    "slug": "interview-072-app-pages-router",
    "title": "72. What is the difference between the App Router and Pages Router?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "The Pages Router maps files in pages to routes and uses APIs such as getStaticProps and getServerSideProps.",
    "series": "interview",
    "questionNumber": "72",
    "contentPath": "/blog/interview-072-app-pages-router.md"
  },
  {
    "slug": "interview-073-server-components",
    "title": "73. What are Server Components?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Server Components execute on the server as part of producing the React Server Component payload.",
    "series": "interview",
    "questionNumber": "73",
    "contentPath": "/blog/interview-073-server-components.md"
  },
  {
    "slug": "interview-074-client-components",
    "title": "74. What are Client Components?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Client Components provide browser interactivity such as state, event handlers and effects.",
    "series": "interview",
    "questionNumber": "74",
    "contentPath": "/blog/interview-074-client-components.md"
  },
  {
    "slug": "interview-075-use-client",
    "title": "75. What does the \"use client\" directive do?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "The directive marks a module as an entry point into the client component graph.",
    "series": "interview",
    "questionNumber": "75",
    "contentPath": "/blog/interview-075-use-client.md"
  },
  {
    "slug": "interview-076-use-server",
    "title": "76. What does the \"use server\" directive do?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "use server marks async functions as Server Functions that can be invoked through framework-managed calls.",
    "series": "interview",
    "questionNumber": "76",
    "contentPath": "/blog/interview-076-use-server.md"
  },
  {
    "slug": "interview-077-ssr-ssg-isr-csr",
    "title": "77. What is the difference between SSR, SSG, ISR, and CSR?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "SSR generates output for a request.",
    "series": "interview",
    "questionNumber": "77",
    "contentPath": "/blog/interview-077-ssr-ssg-isr-csr.md"
  },
  {
    "slug": "interview-078-app-router-rendering",
    "title": "78. How does rendering work in the Next.js App Router?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "The App Router composes Server and Client Components by route segments.",
    "series": "interview",
    "questionNumber": "78",
    "contentPath": "/blog/interview-078-app-router-rendering.md"
  },
  {
    "slug": "interview-079-static-routes",
    "title": "79. How do you create static routes in Next.js?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "A static route path uses fixed folder names, such as app/about/page.tsx for /about.",
    "series": "interview",
    "questionNumber": "79",
    "contentPath": "/blog/interview-079-static-routes.md"
  },
  {
    "slug": "interview-080-dynamic-routes",
    "title": "80. How do you create dynamic routes?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Wrap a folder name in square brackets to capture a URL segment: app/articles/[slug]/page.tsx matches paths such as /articles/closures.",
    "series": "interview",
    "questionNumber": "80",
    "contentPath": "/blog/interview-080-dynamic-routes.md"
  },
  {
    "slug": "interview-081-generate-static-params",
    "title": "81. What is generateStaticParams()?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "generateStaticParams lists parameter combinations that Next.js can use to prerender a dynamic route.",
    "series": "interview",
    "questionNumber": "81",
    "contentPath": "/blog/interview-081-generate-static-params.md"
  },
  {
    "slug": "interview-082-layouts",
    "title": "82. What are layouts in Next.js?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "A layout wraps a route segment and its descendants with shared UI.",
    "series": "interview",
    "questionNumber": "82",
    "contentPath": "/blog/interview-082-layouts.md"
  },
  {
    "slug": "interview-083-layout-template",
    "title": "83. What is the difference between layout.tsx and template.tsx?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Layouts preserve shared UI identity across navigation where the layout remains active.",
    "series": "interview",
    "questionNumber": "83",
    "contentPath": "/blog/interview-083-layout-template.md"
  },
  {
    "slug": "interview-084-loading-ui",
    "title": "84. How do loading UI and loading.tsx work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "loading.tsx defines an immediate fallback for a route segment while its page and descendants perform supported asynchronous rendering work.",
    "series": "interview",
    "questionNumber": "84",
    "contentPath": "/blog/interview-084-loading-ui.md"
  },
  {
    "slug": "interview-085-error-tsx",
    "title": "85. How do error boundaries and error.tsx work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "error.tsx supplies a Client Component fallback for an error boundary around a route segment's descendants.",
    "series": "interview",
    "questionNumber": "85",
    "contentPath": "/blog/interview-085-error-tsx.md"
  },
  {
    "slug": "interview-086-not-found",
    "title": "86. How does not-found.tsx work?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "not-found.tsx defines UI for a missing resource in a route segment.",
    "series": "interview",
    "questionNumber": "86",
    "contentPath": "/blog/interview-086-not-found.md"
  },
  {
    "slug": "interview-087-server-data-fetching",
    "title": "87. How do you fetch data in a Server Component?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Make the Server Component async and await a server-side data operation.",
    "series": "interview",
    "questionNumber": "87",
    "contentPath": "/blog/interview-087-server-data-fetching.md"
  },
  {
    "slug": "interview-088-fetch-caching",
    "title": "88. How does caching work with fetch() in Next.js?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Next.js extends server fetch with cache-related options.",
    "series": "interview",
    "questionNumber": "88",
    "contentPath": "/blog/interview-088-fetch-caching.md"
  },
  {
    "slug": "interview-089-revalidation",
    "title": "89. What is revalidation?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Revalidation updates cached information so reusable output can eventually reflect changed source data.",
    "series": "interview",
    "questionNumber": "89",
    "contentPath": "/blog/interview-089-revalidation.md"
  },
  {
    "slug": "interview-090-time-on-demand-revalidation",
    "title": "90. What is the difference between time-based and on-demand revalidation?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Time-based revalidation allows refresh after a configured freshness interval.",
    "series": "interview",
    "questionNumber": "90",
    "contentPath": "/blog/interview-090-time-on-demand-revalidation.md"
  },
  {
    "slug": "interview-091-revalidate-path-tag",
    "title": "91. What are revalidatePath() and revalidateTag()?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "revalidatePath targets cached output associated with a route path.",
    "series": "interview",
    "questionNumber": "91",
    "contentPath": "/blog/interview-091-revalidate-path-tag.md"
  },
  {
    "slug": "interview-092-use-cache",
    "title": "92. What is the use cache directive?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "use cache marks eligible functions, components or files for caching in Next.js Cache Components.",
    "series": "interview",
    "questionNumber": "92",
    "contentPath": "/blog/interview-092-use-cache.md"
  },
  {
    "slug": "interview-093-route-handlers",
    "title": "93. What are Route Handlers?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Route Handlers define HTTP endpoints in app using route.ts or route.js.",
    "series": "interview",
    "questionNumber": "93",
    "contentPath": "/blog/interview-093-route-handlers.md"
  },
  {
    "slug": "interview-094-crud-apis",
    "title": "94. How do you build CRUD APIs in Next.js?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Map create, read, update and delete operations to HTTP handlers, validate input at the boundary, and enforce authorization before touching persistent data.",
    "series": "interview",
    "questionNumber": "94",
    "contentPath": "/blog/interview-094-crud-apis.md"
  },
  {
    "slug": "interview-095-middleware-proxy",
    "title": "95. What is Next.js Middleware, and when should it be used?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Middleware is the older name for request interception before route handling.",
    "series": "interview",
    "questionNumber": "95",
    "contentPath": "/blog/interview-095-middleware-proxy.md"
  },
  {
    "slug": "interview-096-authenticated-routes",
    "title": "96. How do you protect authenticated routes?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Verify the session on the server and check permission where protected data is read or changed.",
    "series": "interview",
    "questionNumber": "96",
    "contentPath": "/blog/interview-096-authenticated-routes.md"
  },
  {
    "slug": "interview-097-cookies-headers",
    "title": "97. How do cookies and headers work in Server Components?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Current Next.js exposes cookies and headers as asynchronous request APIs.",
    "series": "interview",
    "questionNumber": "97",
    "contentPath": "/blog/interview-097-cookies-headers.md"
  },
  {
    "slug": "interview-098-environment-variables",
    "title": "98. What is the difference between server-side and client-side environment variables?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Server-only environment variables are available to server code and should hold secrets such as database credentials.",
    "series": "interview",
    "questionNumber": "98",
    "contentPath": "/blog/interview-098-environment-variables.md"
  },
  {
    "slug": "interview-099-image-font-script-performance",
    "title": "99. How do next/image, next/font, and next/script improve performance?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "next/image helps deliver appropriately sized images and reserve layout space.",
    "series": "interview",
    "questionNumber": "99",
    "contentPath": "/blog/interview-099-image-font-script-performance.md"
  },
  {
    "slug": "interview-100-optimize-test-deploy",
    "title": "100. How do you optimize, test, and deploy a Next.js application?",
    "date": "September 18, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Treat release quality as a loop: measure a real user journey, make a targeted change, verify behavior, and deploy an artifact you can observe and roll back.",
    "series": "interview",
    "questionNumber": "100",
    "contentPath": "/blog/interview-100-optimize-test-deploy.md"
  },
  {
    "slug": "event-bubbling-capturing-delegation",
    "title": "The DOM and Event Delegation: One Listener for Many Buttons",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Understand DOM nodes, capture and bubble phases, and safely handle dynamic content with one listener.",
    "contentPath": "/blog/event-bubbling-capturing-delegation.md"
  },
  {
    "slug": "fetch-async-await-abort-controller",
    "title": "Fetch with async/await, try/catch, and AbortController",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Handle HTTP failures, JSON errors, timeouts, and cancellation without hiding useful error information.",
    "contentPath": "/blog/fetch-async-await-abort-controller.md"
  },
  {
    "slug": "implementing-debouncing-polyfill",
    "title": "Debounce from Scratch: Search, Cancellation, and Cleanup",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Build a trailing-edge debounce, understand its timeline, and avoid stale search results.",
    "contentPath": "/blog/implementing-debouncing-polyfill.md"
  },
  {
    "slug": "implementing-throttling-polyfill",
    "title": "Throttle from Scratch: Leading Calls and Scroll Work",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Limit frequent events with a small throttle, then choose when trailing calls and animation frames are better.",
    "contentPath": "/blog/implementing-throttling-polyfill.md"
  },
  {
    "slug": "javascript-event-loop",
    "title": "setTimeout, Microtasks, and the Browser Event Loop",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Predict callback order and understand why a zero-delay timer never means immediate execution.",
    "contentPath": "/blog/javascript-event-loop.md"
  },
  {
    "slug": "javascript-function-currying",
    "title": "Currying and Partial Application with Practical Examples",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Turn multi-argument functions into reusable stages and understand where a generic curry helper stops being useful.",
    "contentPath": "/blog/javascript-function-currying.md"
  },
  {
    "slug": "javascript-promises-combinators",
    "title": "Promise.all, allSettled, race, and any: Choose the Right Contract",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Compare success, failure, ordering, and empty inputs with complete asynchronous examples.",
    "contentPath": "/blog/javascript-promises-combinators.md"
  },
  {
    "slug": "js-closures-deep-dive",
    "title": "Closures and Lexical Scope: What a Function Remembers",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Trace variable lookup, create private state, and recognize stale closures in callbacks.",
    "contentPath": "/blog/js-closures-deep-dive.md"
  },
  {
    "slug": "js-execution-context",
    "title": "GEC, FEC, and the Call Stack: Follow JavaScript Execution",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Understand global and function execution contexts without relying on misleading memory-box diagrams.",
    "contentPath": "/blog/js-execution-context.md"
  },
  {
    "slug": "lodash-debounce-throttle-react",
    "title": "Lodash Debounce and Throttle in React Without Stale Timers",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Use a maintained utility, preserve function identity and cancel delayed callbacks when a component unmounts.",
    "contentPath": "/blog/lodash-debounce-throttle-react.md"
  },
  {
    "slug": "nextjs-app-router-pages-router",
    "title": "Next.js App Router vs Pages Router: Files and Boundaries",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Understand layouts, routes, loading UI and client boundaries with a small App Router example.",
    "contentPath": "/blog/nextjs-app-router-pages-router.md"
  },
  {
    "slug": "nextjs-core-web-vitals",
    "title": "Web Vitals and Lighthouse: Fix LCP, INP and CLS",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "Performance",
    "excerpt": "Measure real loading, responsiveness and visual stability, then use repeatable experiments to locate the bottleneck.",
    "contentPath": "/blog/nextjs-core-web-vitals.md"
  },
  {
    "slug": "nextjs-image-optimization",
    "title": "Next.js Image Optimization: Dimensions, Sizes and Loading",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Ship appropriately sized images without layout shifts, and understand the hosting cost of image transforms.",
    "contentPath": "/blog/nextjs-image-optimization.md"
  },
  {
    "slug": "nextjs-ssr-deep-dive",
    "title": "Next.js Rendering: SSR, CSR, SSG and ISR",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "Next.js",
    "excerpt": "Choose when HTML and data are produced, with runnable Pages Router examples and explicit freshness tradeoffs.",
    "contentPath": "/blog/nextjs-ssr-deep-dive.md"
  },
  {
    "slug": "polyfills-map-filter-reduce",
    "title": "Array Polyfills: map, filter, and reduce Edge Cases",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Implement teaching versions without modifying built-ins and test sparse arrays and empty reductions.",
    "contentPath": "/blog/polyfills-map-filter-reduce.md"
  },
  {
    "slug": "prototypal-inheritance-javascript",
    "title": "Prototypes, Inheritance, and the Prototype Chain",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Trace own and inherited properties, understand constructor prototypes, and avoid shared mutable state.",
    "contentPath": "/blog/prototypal-inheritance-javascript.md"
  },
  {
    "slug": "react-actions-optimistic-forms",
    "title": "React 19 Forms: Actions, Optimistic UI, and Form Status",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Use action state and pending feedback with working local examples, then understand optimistic rollback.",
    "contentPath": "/blog/react-actions-optimistic-forms.md"
  },
  {
    "slug": "react-advanced-hooks",
    "title": "Advanced Hooks: Reducers, Memoization, and External Stores",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Use reducers for transitions, refs for imperative handles, and stable snapshots for subscriptions.",
    "contentPath": "/blog/react-advanced-hooks.md"
  },
  {
    "slug": "react-effects-cleanup",
    "title": "React Effects: Cleanup, Dependencies, and Aborted Requests",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Build a data-loading component that survives unmounts, changing IDs, and Strict Mode.",
    "contentPath": "/blog/react-effects-cleanup.md"
  },
  {
    "slug": "react-error-boundary-suspense-lazy",
    "title": "Error Boundaries, Suspense, and Lazy Code Splitting",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Build separate loading and failure states for a lazily imported feature, with copyable multi-file examples.",
    "contentPath": "/blog/react-error-boundary-suspense-lazy.md"
  },
  {
    "slug": "react-fiber-virtual-dom-diffing",
    "title": "React Fiber, Virtual DOM, and Reconciliation",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Understand render versus commit, stable keys, and why Fiber does not make all JavaScript concurrent.",
    "contentPath": "/blog/react-fiber-virtual-dom-diffing.md"
  },
  {
    "slug": "react-hooks-complete-guide",
    "title": "React Hooks: A Practical Map of the Built-in APIs",
    "date": "September 17, 2026",
    "readTime": "4 min read",
    "category": "React",
    "excerpt": "Choose the right hook for state, effects, refs, performance, external stores, and React 19 actions.",
    "contentPath": "/blog/react-hooks-complete-guide.md"
  },
  {
    "slug": "redux-redux-toolkit-practical",
    "title": "Redux and Redux Toolkit: A Complete Small Store",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "React",
    "excerpt": "Understand actions, reducers, selectors, and Immer by building a small shared counter with Redux Toolkit.",
    "contentPath": "/blog/redux-redux-toolkit-practical.md"
  },
  {
    "slug": "scope-shadowing-illegal-shadowing",
    "title": "Block Scope, Shadowing, and the Temporal Dead Zone",
    "date": "September 17, 2026",
    "readTime": "3 min read",
    "category": "JavaScript",
    "excerpt": "Explain let, const, var, loop closures, and redeclaration errors with runnable examples.",
    "contentPath": "/blog/scope-shadowing-illegal-shadowing.md"
  },
  {
    "slug": "react-compiler-mastery",
    "title": "Mastering the React 19 Compiler",
    "date": "June 28, 2026",
    "readTime": "6 min read",
    "category": "React",
    "excerpt": "An in-depth look at how the new React Compiler automates memoization, rendering optimization, and simplifies code architecture.",
    "contentPath": "/blog/react-compiler-mastery.md"
  },
  {
    "slug": "typescript-advanced-utility-types",
    "title": "TypeScript Advanced Utility Types",
    "date": "June 25, 2026",
    "readTime": "5 min read",
    "category": "TypeScript",
    "excerpt": "Explore powerful utility types, mapped types, conditional types, and template literal types to craft bulletproof type definitions.",
    "contentPath": "/blog/typescript-advanced-utility-types.md"
  },
  {
    "slug": "deep-dive-microfrontends",
    "title": "A Deep Dive into Microfrontends",
    "date": "June 20, 2026",
    "readTime": "8 min read",
    "category": "Frontend",
    "excerpt": "Learn how to structure modular frontend architectures, deploy independently, and integrate dynamically using Webpack Module Federation.",
    "contentPath": "/blog/deep-dive-microfrontends.md"
  },
  {
    "slug": "aem-headless-integration",
    "title": "AEM Headless Integration Patterns",
    "date": "June 10, 2026",
    "readTime": "6 min read",
    "category": "Frontend",
    "excerpt": "Best practices for consuming Adobe Experience Manager Content Fragments dynamically inside React and Next.js applications.",
    "contentPath": "/blog/aem-headless-integration.md"
  },
  {
    "slug": "fluid-cursor-interactions",
    "title": "Building Fluid Custom Cursor Effects",
    "date": "June 05, 2026",
    "readTime": "5 min read",
    "category": "Frontend",
    "excerpt": "A guide to building smooth lagging cursors using custom hooks, requestAnimationFrame, and performance-tuned CSS in React.",
    "contentPath": "/blog/fluid-cursor-interactions.md"
  },
  {
    "slug": "storybook-testing-best-practices",
    "title": "Effective Component Testing with Storybook",
    "date": "May 28, 2026",
    "readTime": "6 min read",
    "category": "Frontend",
    "excerpt": "Leverage Storybook interaction testing, Mock Service Worker integration, and visual regression tests to protect UI packages.",
    "contentPath": "/blog/storybook-testing-best-practices.md"
  },
  {
    "slug": "react-native-perf",
    "title": "Performance Optimization in React Native",
    "date": "May 20, 2026",
    "readTime": "7 min read",
    "category": "React",
    "excerpt": "Optimize React Native application performance by addressing bridge traffic, memory leaks, image loading, and list rendering.",
    "contentPath": "/blog/react-native-perf.md"
  },
  {
    "slug": "css-grid-vs-flexbox",
    "title": "CSS Grid vs. Flexbox: Layout Mastery",
    "date": "May 15, 2026",
    "readTime": "5 min read",
    "category": "Frontend",
    "excerpt": "Understand when to use CSS Grid versus Flexbox to create highly responsive, dynamic, and clean web structures.",
    "contentPath": "/blog/css-grid-vs-flexbox.md"
  },
  {
    "slug": "frontend-cicd-github-actions",
    "title": "Mastering CI/CD Pipelines for Frontend",
    "date": "May 10, 2026",
    "readTime": "6 min read",
    "category": "TypeScript",
    "excerpt": "Automate your checks, type compilations, component tests, and serverless deployments using GitHub Actions.",
    "contentPath": "/blog/frontend-cicd-github-actions.md"
  },
  {
    "slug": "hoisting-temporal-dead-zone",
    "title": "Understanding Hoisting & Temporal Dead Zone",
    "date": "May 02, 2026",
    "readTime": "5 min read",
    "category": "JavaScript",
    "excerpt": "Discover the difference in hoisting behavior between var, let, and const, and why the Temporal Dead Zone exists.",
    "contentPath": "/blog/hoisting-temporal-dead-zone.md"
  },
  {
    "slug": "call-apply-bind-polyfills",
    "title": "Understanding Call, Apply, & Bind with Polyfills",
    "date": "April 10, 2026",
    "readTime": "6 min read",
    "category": "JavaScript",
    "excerpt": "Learn how to explicitly bind JavaScript contexts and build polyfills for call, apply, and bind.",
    "contentPath": "/blog/call-apply-bind-polyfills.md"
  },
  {
    "slug": "event-loop-vs-call-stack",
    "title": "Deep Dive: Event Loop vs. Call Stack",
    "date": "March 15, 2026",
    "readTime": "5 min read",
    "category": "JavaScript",
    "excerpt": "Trace how the JS engine moves functions from the Call Stack through Web APIs into queues.",
    "contentPath": "/blog/event-loop-vs-call-stack.md"
  },
  {
    "slug": "functions-first-class-higher-order",
    "title": "First-Class, Higher-Order, and Anonymous Functions",
    "date": "March 05, 2026",
    "readTime": "5 min read",
    "category": "JavaScript",
    "excerpt": "Learn the core taxonomy of functions in functional JavaScript and how they are manipulated.",
    "contentPath": "/blog/functions-first-class-higher-order.md"
  },
  {
    "slug": "memoization-polyfill-optimization",
    "title": "Memoization Polyfill: Optimizing Heavy Tasks",
    "date": "February 20, 2026",
    "readTime": "5 min read",
    "category": "JavaScript",
    "excerpt": "Write a custom memoize function that caches arguments to optimize CPU-heavy procedures.",
    "contentPath": "/blog/memoization-polyfill-optimization.md"
  },
  {
    "slug": "javascript-map-set-weakmap-weakset",
    "title": "JavaScript Map, Set, WeakMap, & WeakSet",
    "date": "February 15, 2026",
    "readTime": "6 min read",
    "category": "JavaScript",
    "excerpt": "Explore the ES6 collections and understand the key garbage-collection advantages of WeakMap and WeakSet.",
    "contentPath": "/blog/javascript-map-set-weakmap-weakset.md"
  },
  {
    "slug": "debounce-vs-throttle-scenarios",
    "title": "Debounce vs. Throttle: Real-world Scenarios",
    "date": "February 05, 2026",
    "readTime": "5 min read",
    "category": "Frontend",
    "excerpt": "Deep comparison of debouncing vs throttling with visual examples of resize, search search bars, and click events.",
    "contentPath": "/blog/debounce-vs-throttle-scenarios.md"
  },
  {
    "slug": "nextjs-server-actions-hydration",
    "title": "Next.js Server Actions & Hydration Strategy",
    "date": "January 28, 2026",
    "readTime": "6 min read",
    "category": "React",
    "excerpt": "Learn how to invoke server-side operations directly within forms using modern Next.js Server Actions.",
    "contentPath": "/blog/nextjs-server-actions-hydration.md"
  }
];
